import { defaultConfig, defineSlotRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

export const menuSlotRecipe = defineSlotRecipe(
    merge(defaultConfig?.theme?.slotRecipes?.menu, {
        base: {
            trigger: {
                cursor: 'pointer',
                color: 'secondary.500',
                borderColor: 'transparent',
                px: 4,
                py: 3,
                _hover: {
                    bg: 'transparent',
                },
                _active: {
                    bg: 'transparent',
                },
                // _focusVisible: {
                //     outlineWidth: 0,
                // },
            },
            content: {
                overflow: 'visible',
                overflowY: 'visible',
                position: 'relative',
                borderRadius: 0,
            },
            itemGroupLabel: {
                fontSize: 'md',
                pl: 1,
                py: 1,
                color: 'black',
                textTransform: 'uppercase',
            },
            item: {
                color: 'black',
            },
        },
    }),
);
